import _ from 'lodash';
import { FieldTypes } from '../../types/carrierQuestionnaire/fieldTypes';
import { isTextFieldType } from '../structure';
export function isRenderingTextField(field) {
    return isTextFieldType(field.type);
}
export function isRenderingRadioField(field) {
    return field.type === FieldTypes.radio;
}
export function isRenderingCheckboxGroupField(field) {
    return field.type === FieldTypes.checkboxGroup;
}
export function isRenderingAgreeField(field) {
    return field.type === FieldTypes.agree;
}
export function isRenderingButtonField(field) {
    return field.type === FieldTypes.button;
}
export function isRenderingAutocompleteField(field) {
    return field.type === FieldTypes.autocomplete;
}
export function isRenderingPlaceholderField(field) {
    return !!field.placeholder;
}
export function isRenderingOptionField(field) {
    return !_.isEmpty(field.options);
}
export function isRenderingRepeatedSectionGroup(sectionGroup) {
    return _.get(sectionGroup, ['options', 'repeatable'], false);
}
export function isRenderingRepeatedFieldGroup(fieldGroup) {
    return _.get(fieldGroup, ['options', 'repeatable'], false);
}
export function isRenderingInformationField(field) {
    return field.type === FieldTypes.information;
}
